import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7dbea06d&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=7dbea06d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbea06d",
  null
  
)

export default component.exports